import { getDefaultHeaders, setCsrfToken } from "./utils";

export async function submitJobForEditing(file_id) {
  let headers = await getDefaultHeaders(true, true);
  const requestOptions = {
    method: "POST",
    headers: headers,
  };
  const url = `/api/submit-job-editing/${file_id}/`;
  try {
    const response = await fetch(url, requestOptions);
    if (response.status === 403) {

      await setCsrfToken();
      return await submitJobForEditing(file_id)
    }
    return response;
  } catch (err) {
    console.log("ERROR 17", err);
    return [];
  }
}
